import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, Fragment as _Fragment } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "loading"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Loading = _resolveComponent("Loading")!
  const _component_Display = _resolveComponent("Display")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("h3", null, _toDisplayString(_ctx.$t('details.codeSummary')), 1),
    (_openBlock(), _createElementBlock("div", {
      class: "langcont",
      key: _ctx.key
    }, [
      (_ctx.langarray.length < 2)
        ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
            _createVNode(_component_Loading)
          ]))
        : (_openBlock(), _createBlock(_component_Display, {
            key: 1,
            langs: _ctx.langarray
          }, null, 8, ["langs"]))
    ]))
  ], 64))
}